import { MAX_COUNTRY_NAME } from 'config';

const getShortName = (
  name: string | undefined,
  customNumber?: number
): string => {
  if (!name) return '';
  const nameLength = customNumber || MAX_COUNTRY_NAME;
  return name?.length > nameLength
    ? `${name?.slice(0, nameLength).trim()}...`
    : name;
};

export default getShortName;
